import { ArrowLeftRight, Warehouse } from 'lucide-react';

/**
 * The two areas a signed-in account moves between, and the door from one to
 * the other.
 *
 * The platform is the OMS: orders, deliveries, couriers. Under `/warehouse`
 * it is the WMS: the inventory and the floor. The sidebar names the area under
 * the logo and, right under the user, offers the way across. The door is not a
 * menu entry on purpose: a menu lists the places of the area one is in, and
 * the other area is not one of them.
 *
 * "Carga tus órdenes" is offered in both: an order is loaded the same way
 * whichever side one is standing on.
 */
export const AREA_LABELS = { oms: 'OMS', wms: 'WMS' };

/** Where the warehouse module lives. Everything under it is "inside". */
export const WAREHOUSE_ROOT = '/warehouse';

/** Where the module opens: the orders, which is what one comes in to work on. */
export const WAREHOUSE_HOME = `${WAREHOUSE_ROOT}/orders`;

/** Into the WMS, from the platform. */
export const toWmsSwitch = {
  to: WAREHOUSE_HOME,
  icon: Warehouse,
  label: 'Ir a WMS',
};

/** Back to the OMS, from the module. */
export const toOmsSwitch = {
  to: '/dashboard',
  icon: ArrowLeftRight,
  label: 'Ir al OMS',
};

/** Whether `pathname` is inside the warehouse module. */
export const isWarehousePath = (pathname) =>
  pathname === WAREHOUSE_ROOT || pathname.startsWith(`${WAREHOUSE_ROOT}/`);

/**
 * What the sidebar says about the area and which door it offers.
 *
 * The platform always says OMS, module or not: the name is what tells the two
 * sides apart, and an account that will get the module later should not see
 * its sidebar change twice. Without the module there is no door either way.
 *
 * @param {object} params
 * @param {boolean} params.hasWarehouse - Whether the plan carries the module.
 * @param {boolean} params.inWarehouse
 * @returns {{areaLabel: string|undefined, areaSwitch: object|null}}
 */
export const pickArea = ({ hasWarehouse, inWarehouse }) => {
  if (!hasWarehouse) return { areaLabel: AREA_LABELS.oms, areaSwitch: null };
  return inWarehouse
    ? { areaLabel: AREA_LABELS.wms, areaSwitch: toOmsSwitch }
    : { areaLabel: AREA_LABELS.oms, areaSwitch: toWmsSwitch };
};
